import React, { useEffect, useRef, useState } from 'react'
import { Tabs, Tab } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import { ArrowBackIcon } from "~/Components/Icons/Icons";
import { adminHttp } from "~/Admin/services/http";
import { connect } from "react-redux";
import { invitationProgress } from '~/helpers/invitation';
import { declineReasons } from '~/helpers/dictionary'
import AdminGuestPreview from "./AdminGuestPreview";
import AdminRegistrationInvitees from "./AdminRegistrationInvitees";
import AdminRegistrationTickets from "./AdminRegistrationTickets";
import AdminRegistrationCommunications from "./AdminRegistrationCommunications";
import AdminRegistrationComments from "./AdminRegistrationComments";
import AdminEditRsvp from "./AdminEditRsvp";
import { humanFileSize } from "~/helpers/utils";
import AdminEditInvitationDetails from './AdminEditInvitationDetails';
import AdminEditPersonalDetails from './AdminEditPersonalDetails';
import { capitalize } from '../../../helpers/utils';

const AdminViewRegistration = ({ event, match, ...props }) => {

    const [invitation, setInvitation] = useState(null);
    const [guest, setGuest] = useState(false);
    const endpoint = `/events/${event.id}/invitations/${match.params.id}`;

    const history = useHistory();
    const isFirstRun = useRef(true);

    const loadData = () => {
        adminHttp
            .get(endpoint)
            .then(res => {
                setInvitation(res.data);
            });
    };

    useEffect(() => {
        if (isFirstRun.current) { return; }
        history.push('/guests/registration');
    }, [event])

    useEffect(() => {
        if (isFirstRun.current) { return; }
        setGuest(invitation.guests.find(g => g.main))
    }, [invitation]);

    useEffect(() => {
        if (isFirstRun.current) { isFirstRun.current = false; }
        loadData();
    }, []);

    if (!invitation) {
        return <></>
    }

    const progress = invitationProgress(invitation.guests);

    return (
        <div>
            <Link className="btn btn-secondary btn-sm mb-4" onClick={() => history.goBack()}>
                <ArrowBackIcon classes="d-inline mr-2" />
                Back
            </Link>

            <div className="row">
                <div className="col-6">
                    <h2>{guest?.full_name || invitation.user.full_name}</h2>
                </div>

                <div className="col-6 text-right">
                    <AdminEditRsvp
                        onChange={loadData}
                        className="btn btn-primary btn-icon btn-sm"
                        invitation={invitation}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-4">
                    <div className="card shadow-sm bg-white mt-3">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h3>Personal Details</h3>
                                <AdminEditPersonalDetails
                                    icon={true}
                                    onChange={loadData}
                                    guest={guest}
                                />
                            </div>
                            <div className="row">
                                <div className="col-5 font-weight-500 text-nowrap">Email</div>
                                <div className="col-7">
                                    {guest?.email}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-5 font-weight-500 text-nowrap">Phone</div>
                                <div className="col-7">
                                    {guest?.phone}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-5 font-weight-500 text-nowrap">Company</div>
                                <div className="col-7">
                                    {guest?.company || '-'}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-5 font-weight-500 text-nowrap">Job Title</div>
                                <div className="col-7">
                                    {guest?.job_title || '-'}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-5 font-weight-500 text-nowrap">Guest Group</div>
                                <div className="col-7">{capitalize(guest?.guest_group) || '-'}</div>
                            </div>
                        </div>
                    </div>

                    <div className="card shadow-sm bg-white mt-3">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h3 className="mb-0">Invitation Details</h3>
                                <AdminEditInvitationDetails
                                    onChange={loadData}
                                    guest={guest?.invitation}
                                    invitationUser={invitation?.user}
                                />
                            </div>
                            <div className="row">
                                <div className="col-5 font-weight-500 text-nowrap">Wave</div>
                                <div className="col-7">{invitation.wave?.name}</div>
                            </div>
                            <div className="row">
                                <div className="col-5 font-weight-500 text-nowrap">Package</div>
                                <div className="col-7">{invitation.package.name}</div>
                            </div>
                            <div className="row">
                                <div className="col-5 font-weight-500 text-nowrap">Language</div>
                                <div className="col-7">{invitation.user?.language?.name || '-'}</div>
                            </div>
                            <div className="row">
                                <div className="col-5 font-weight-500 text-nowrap">Number of Invitees</div>
                                <div className="col-7">{invitation.guest_allowance || '-'}</div>
                            </div>
                            <div className="row">
                                <div className="col-5 font-weight-500 text-nowrap">NEOM Department</div>
                                <div className="col-7">{invitation?.neom_department?.name || '-'}</div>
                            </div>
                            {invitation.data_validation && (
                                <div className="row">
                                    <div className="col-5 font-weight-500 text-nowrap">File</div>
                                    <div className="col-7">{invitation.data_validation?.name || '-'}</div>
                                </div>
                            )}

                            {invitation.itinerary && invitation.itinerary.document && (
                                <div className="row">
                                    <div className="col-5 font-weight-500 text-nowrap">Itinerary</div>
                                    <div className="col-7">
                                        <a className="d-block small" href={invitation.itinerary.document.download_url}>{invitation.itinerary.document.name} ({humanFileSize(invitation.itinerary.document.size)})</a>
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>

                    <div className="card shadow-sm bg-white mt-3">
                        <div className="card-body">
                            <h3>Registration Progress</h3>
                            <div className="row">
                                <div className="col-5 font-weight-500 text-nowrap">RSVP</div>
                                <div className="col-7">{invitation.rsvp_status}</div>
                            </div>
                            {invitation.rsvp_status === 'confirmed' && (
                                <>
                                    <div className="row">
                                        <div className="col-5 font-weight-500 text-nowrap">Registration</div>
                                        <div className="col-7">{invitation.registration_status}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-5 font-weight-500 text-nowrap">Progress</div>
                                        <div className="col-7">{progress.finished} / {progress.total} ({progress.percent}%)</div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
                {invitation.rsvp_status === 'declined' && (
                    <div className="col-8">
                        <div className="card shadow-sm bg-white mt-3">
                            <div className="card-body">
                                <h3>Invitation Declined</h3>
                                <p>This user has declined to attend this event.</p>
                                <hr />
                                <label className="font-weight-500">Reasons for declining:</label>
                                <p>{declineReasons[invitation.decline_reason]}</p>
                                <label className="font-weight-500">Future experiences:</label>
                                <p>
                                    {invitation.consider_in_future ? 'Yes, I would like to be considered for future NEOM experiences.' : 'No.'}
                                </p>
                            </div>
                        </div>
                    </div>
                )}

                {invitation.rsvp_status === 'confirmed' && (
                    <div className="col-8">
                        <div className="card shadow-sm bg-white mt-3">
                            <div className="card-body">
                                <Tabs mountOnEnter={true} unmountOnExit={true} defaultActiveKey="registration" transition={false}>
                                    <Tab eventKey="registration" title="Registration">
                                        <AdminGuestPreview guest={guest} loadData={loadData} />
                                    </Tab>
                                    <Tab eventKey="invitees" title="Guest Invitees">
                                        <AdminRegistrationInvitees guests={invitation.guests} />
                                    </Tab>
                                    <Tab eventKey="tickets" title="Tickets">
                                        <AdminRegistrationTickets guests={invitation.guests} />
                                    </Tab>
                                    <Tab eventKey="comms" title="Communications">
                                        <AdminRegistrationCommunications onChange={loadData} invitation={invitation} />
                                    </Tab>
                                    <Tab eventKey="comments" title="Comments">
                                        <AdminRegistrationComments invitation={invitation} />
                                    </Tab>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminViewRegistration);
